import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState({ artworks: 0, collections: 0, journal: 0, orders: 0, messages: 0, commissions: 0 });

  useEffect(() => {
    Promise.all([
      api.get("/admin/artworks"),
      api.get("/collections"),
      api.get("/admin/journal"),
      api.get("/admin/orders"),
      api.get("/admin/contact-messages"),
      api.get("/admin/commissions"),
    ]).then(([a, c, j, o, m, cm]) => {
      setStats({
        artworks: a.data.length,
        collections: c.data.length,
        journal: j.data.length,
        orders: o.data.filter((x) => x.payment_status === "paid").length,
        messages: m.data.length,
        commissions: cm.data.length,
      });
    });
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <p className="eyebrow mb-3">Studio</p>
      <h1 className="font-serif text-5xl font-light mb-14">Overview</h1>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
        <Card label="Artworks" value={stats.artworks} to="/admin/artworks" />
        <Card label="Collections" value={stats.collections} to="/admin/collections" />
        <Card label="Journal posts" value={stats.journal} to="/admin/journal" />
        <Card label="Paid orders" value={stats.orders} to="/admin/orders" />
        <Card label="Messages" value={stats.messages} to="/admin/messages" />
        <Card label="Commission enquiries" value={stats.commissions} to="/admin/messages" />
      </div>

      <div className="mt-16 border-t border-border pt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
        <Link to="/admin/artworks/new" className="btn-ink text-center" data-testid="quick-add-artwork">+ Add new artwork</Link>
        <Link to="/admin/journal/new" className="btn-outline-ink text-center" data-testid="quick-add-journal">+ Write a journal note</Link>
      </div>
    </div>
  );
}

function Card({ label, value, to }) {
  return (
    <Link to={to} className="border border-border p-8 hover:border-foreground transition-colors block" data-testid={`stat-${label.toLowerCase().replace(/\s/g, "-")}`}>
      <p className="eyebrow text-muted-foreground mb-4">{label}</p>
      <p className="font-serif text-5xl font-light tabular-nums">{value}</p>
    </Link>
  );
}
